import './AadhaarPrintComp.css'; 
 import addrhintext from '../Pics/addrtexthindi.jpg'
 import addrengtext from '../Pics/sddresstext.jpg'
 import SharePage from '../SharePage.js';

let AadhaarPrintComp=(props)=>{
   if(props.inputs.engname==undefined){
      window.location="/aadhaarcard-manual";
   } 
   let pritnfun=()=>{
      window.print();
      document.querySelector(".printaadhardiv").style.display="none";
      document.querySelector(".sharecont").style.display="block";
   } 
     
    return(
        <div className='maindiv'>
             <div className='printaadhardiv'>
                  {
                     
                     props.inputs.AadharNoIssued != undefined ? <span className='adhrnoissued'>Aadhaar no issued:{props.inputs.AadharNoIssued}</span> : ""
                  }
                  <img alt='Photo' className='propropic' src={props.inputs.photo}/>
                  <div className='detailss'>
                  <p>{props.inputs.hinname}</p> 
                  <p>{props.inputs.engname}</p>
                  <p>जन्म तिथि/DOB: {props.inputs.dob}</p>  
                  <p>{ props.inputs.gender}</p>
                  </div>
                  <p className='aadharnum'>{props.inputs.aadharnum}</p>
                  <div className='addrandqrcont'>
                     <div className='addrdinengcont'>
                        <p className='addrhindi'>
                           <img alt='photo' className='addrpichin' src={addrhintext}/>
                           {props.inputs.addrhin}   </p>
                        <p className='addrenglish'>
                           <img alt='address' className='addrpiceng' src={addrengtext}/>
                           {props.inputs.addreng}  
                        </p>
                     </div>
                     {
                        props.inputs.qr != null ? <img alt='qr code' className='qr' src={props.inputs.qr}/> : ""
                     }
                    
                  </div>
                  
                  <p className='backsideaadharnum'>{props.inputs.aadharnum}</p>
                  {
                     props.inputs.vid != undefined ? <p className='vid'><span>VID :</span> {props.inputs.vid}</p> : ""
                  }
                  
                  
                  { 
                     props.inputs.detailsason != undefined ? <span className='detailsason'>Details as on: {props.inputs.detailsason}</span> : ""
                  }
                  <button onClick={pritnfun} className='printbtn'>Print</button>
            </div>
            <div className='sharecont' style={{display:"none"}}>
               <p style={{color:"green", fontSize:"25px", textAlign:"center"}}>Share Aadhar manual print tool</p>
               <SharePage path='/MakeResume' title='Make free resumes' description="Make resumes for jobs, schools and many more for free"/>

            </div>
           
        </div>
    );
}
export default AadhaarPrintComp;